import React, { useState } from 'react';
import { PageContentLayout, PageHeaderLayout } from '../../../shared/layout';
import { CompressOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import TargetingLocationTab from '../../OrgConfig/components/Targeting/TargetingLocationTab';
import { determineUserAccess } from '../../../../core/permissions/userLevelAccess';
import HelpCenterModal from '../../../shared/components/HelpCenterModal/HelpCenterModal';
import { buildUserActions } from '../../../../core/utils/helpCenter/buildUserActions';
import '../../OrgConfig/components/Targeting/styles/_targeting.scss';

const TargetingMainView = ({
  currentuser,
  setAudienceAmplifyDefault,
  attributionAudienceName,
  createTargetingLocation,
  deleteLocation,
  google,
  locationList,
  onChangeStateValue,
  onCsvUploadComplete,
  onSubmitAudience,
  onAddToExistingAudience,
  selectedLocations,
  updateTargetingLocation,
  isTargetingPreviewModalOpen,
  targetingLocationsPreviewData,
  closeTargetingPreviewModal,
  bulkImportTargetingLocations,
  selectTargetingLocationPreview,
  targetingAudiences,
  deleteAudienceLocation,
  deleteBulkLocation,
  handleSubmitRegionGroup,
  handleUpdateRegionGroup,
  deleteRegionGroup,
  regionGroups,
  handleSubmitIABCategoryGroup,
  iABCategoryGroups,
  deleteIABCategoryGroup,
  selectedOrg,
  dealIds,
  createDealId,
  deleteDealIds,
  updateDealId,
  presetRegionGroups,
  presetRegionGroupsLoading,
}) => {
  //Title shown on browser tab
  document.title = 'Targeting Main View';

  const { permission, isPreviewOrg } = currentuser;
  const userPermission = determineUserAccess(permission);

  const { isSelfService, amplify } = userPermission;

  const userActions = buildUserActions(userPermission, currentuser.features);

  const [helpVisible, setHelpVisible] = useState(false);

  return (
    <React.Fragment>
      <div className="targeting-page-header">
        <PageHeaderLayout
          titleIcon={<CompressOutlined />}
          title={'Targeting'}
          rightContent={
            <Button
              type="default"
              icon={<QuestionCircleOutlined />}
              onClick={() => setHelpVisible(true)}
            >
              Help Center
            </Button>
          }
        />
      </div>
      <PageContentLayout>
        <div className="targeting-root">
          <TargetingLocationTab
            setAudienceAmplifyDefault={setAudienceAmplifyDefault}
            attributionAudienceName={attributionAudienceName}
            createTargetingLocation={createTargetingLocation}
            deleteLocation={deleteLocation}
            google={google}
            locationList={locationList}
            onChangeStateValue={onChangeStateValue}
            onCsvUploadComplete={onCsvUploadComplete}
            onSubmitAudience={onSubmitAudience}
            onAddToExistingAudience={onAddToExistingAudience}
            selectedLocations={selectedLocations}
            updateTargetingLocation={updateTargetingLocation}
            isTargetingPreviewModalOpen={isTargetingPreviewModalOpen}
            targetingLocationsPreviewData={targetingLocationsPreviewData}
            closeTargetingPreviewModal={closeTargetingPreviewModal}
            bulkImportTargetingLocations={bulkImportTargetingLocations}
            selectTargetingLocationPreview={selectTargetingLocationPreview}
            targetingAudiences={targetingAudiences}
            deleteAudienceLocation={deleteAudienceLocation}
            deleteBulkLocation={deleteBulkLocation}
            handleSubmitRegionGroup={handleSubmitRegionGroup}
            handleUpdateRegionGroup={handleUpdateRegionGroup}
            deleteRegionGroup={deleteRegionGroup}
            regionGroups={regionGroups}
            handleSubmitIABCategoryGroup={handleSubmitIABCategoryGroup}
            iABCategoryGroups={iABCategoryGroups}
            deleteIABCategoryGroup={deleteIABCategoryGroup}
            selectedOrg={selectedOrg}
            isSelfService={isSelfService}
            isPreviewOrg={isPreviewOrg}
            amplify={amplify}
            dealIds={dealIds}
            createDealId={createDealId}
            deleteDealIds={deleteDealIds}
            updateDealId={updateDealId}
            presetRegionGroups={presetRegionGroups}
            presetRegionGroupsLoading={presetRegionGroupsLoading}
            currentuser={currentuser}
          />
        </div>
      </PageContentLayout>
      <HelpCenterModal
        visible={helpVisible}
        onClose={() => setHelpVisible(false)}
        feature="TARGETING"
        title="Targeting Help Center"
        userActions={userActions}
      />
    </React.Fragment>
  );
};

export default TargetingMainView;
